import {createContext, useContext, useMemo, useState} from "react";


export const LayoutContext = createContext({});

export const LayoutProvider = ({children}) => {
    const [openNavigation, setOpenNavigation] = useState(true);

    const value = useMemo(() => ({
        openNavigation, setOpenNavigation
    }), [openNavigation]);

    return <LayoutContext.Provider value={value}>{children}</LayoutContext.Provider>;
};

export const useLayout = () => {
    return useContext(LayoutContext);
};